// extracted by mini-css-extract-plugin
export var brand = "_9v-9";
export var compact = "_9v-6";
export var extraSmall = "_9v-7";
export var icon = "_9v-0";
export var large = "_9v-4";
export var light = "_9v-1";
export var medium = "_9v-5";
export var outline = "_9v-b";
export var primaryDark = "_9v-a";
export var primaryLight = "_9v-8";
export var primaryModern = "_9v-c";
export var success = "_9v-2";
export var successSolid = "_9v-3";